export const DEFAULT_FOOTER_CTA = {
  heading: 'Ready to optimize your production?',
  text: 'Contact our engineering team today for a customized consultation on how Sahil Machines can transform your shop floor.',
} as const;

export type FooterCtaCopy = {
  heading: string;
  text: string;
};

export function resolveFooterCta(
  heading?: string | null,
  text?: string | null,
): FooterCtaCopy {
  const resolvedHeading = heading?.trim();
  const resolvedText = text?.trim();

  return {
    heading: resolvedHeading || DEFAULT_FOOTER_CTA.heading,
    text: resolvedText || DEFAULT_FOOTER_CTA.text,
  };
}
